module.exports = __webpack_public_path__ + "static/media/max_bid_icon.787a8db3.png";